<template>
  <div>
    <select-content-single
      v-if="single"
      :value="value"
      v-bind="selectContentOptions"
      :disabled="disabled"
      :placeholder="$attrs.placeholder"
      @change="change"
      @click.native="showOuter"
    />
    <select-content-multiple
      v-else
      :value="value"
      v-bind="selectContentOptions"
      :disabled="disabled"
      :placeholder="$attrs.placeholder"
      @change="change"
      @click.native="showOuter"
    />
  </div>
</template>

<script>
import selectContentMultiple from './selectContentMultiple';
import selectContentSingle from './selectContentSingle';
export default {
  components: {
    selectContentMultiple,
    selectContentSingle
  },
  props: {
    single: {
      default: false,
      type: Boolean
    },
    value: {
      type: [Array, Object]
    },
    selectContentOptions: {
      default: () => {
        return {};
      },
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    change(v) {
      this.$emit('input', v);
    },
    showOuter() {
      if (this.disabled) return;
      this.$emit('showOuter');
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .biz-selector-content {
  position: relative;
  box-sizing: border-box;
  min-height: 40px;
  padding: 7px 36px 0 12px;
  color: #595959;
  line-height: 24px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &.disabled {
    color: #bfbfbf;
    background-color: #f5f5f5;
    cursor: not-allowed;

    &:hover {
      border-color: #d9d9d9;
    }

    * {
      pointer-events: none;
    }
  }

  &:hover {
    border-color: #436bef;
  }

  .biz-selector-content-taglist {
    margin-bottom: 1px;
  }

  .biz-selector-content__icon {
    position: absolute;
    top: 50%;
    right: 6px;
    z-index: 10;
    font-size: 16px;
    transform: translateY(-50%);
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.yxt-form-item.is-error .biz-selector-content,
.yxt-form-item.is-error .biz-selector-content:focus {
  border-color: #f5222d;
}
</style>
